var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',_vm._b({attrs:{"src":_vm.getSourceOnce(_vm.attributes.value),"controlsList":"nodownload","playsinline":"","muted":""},domProps:{"muted":true}},'video',_vm.attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }